import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, Sparkles, Rocket } from "lucide-react";

const steps = [
  {
    icon: ClipboardList,
    step: "1",
    title: "Enter Your Business Details",
    description:
      "Tell us your business name, industry, target customer, and what makes you stand out. Takes less than 30 seconds.",
  },
  {
    icon: Sparkles,
    step: "2",
    title: "We Generate Your Value Proposition",
    description:
      "Our AI crafts a custom value proposition optimised for Google Ads — including headline copy, descriptions, and landing page hooks.",
  },
  {
    icon: Rocket,
    step: "3",
    title: "Use It in Your Campaigns",
    description:
      "Receive your value proposition by email, ready to paste into your Google Ads. We include tips on where and how to use each variation.",
  },
];

const VPGHowItWorks = () => {
  return (
    <section className="py-24 px-4 bg-muted/30">
      <div className="container mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <Badge className="px-3 py-1 text-sm bg-primary/10 text-primary border-primary/20 mb-4">
              How It Works
            </Badge>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-6">
              Get Your Value Proposition in 3 Simple Steps
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">
          {/* Connector line (desktop only) */}
          <div className="hidden md:block absolute top-16 left-[20%] right-[20%] h-0.5 bg-primary/20" />

          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              className="text-center relative"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
            >
              <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center mx-auto mb-6 text-2xl font-bold relative z-10">
                {step.step}
              </div>
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-4">
                <step.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-xl font-bold mb-3">{step.title}</h3>
              <p className="text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VPGHowItWorks;
